import React from "react";

const FeedBackIcon = ({ viewBox = "0 0 22 20", className = "hayley-h-[18px] hayley-w-[20px] hayley-text-white" }) => {
  return (
    <svg data-testid="feedback-icon" width={22} height={20} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M2.94196 18.7781H1V13.5493H2.94196" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M2.94214 13.5489L4.8841 7.27441H5.36959C5.75587 7.27441 6.12633 7.43968 6.39947 7.73385C6.67261 8.02803 6.82606 8.42702 6.82606 8.84304V11.4574H10.0012C10.2098 11.4574 10.4161 11.5057 10.6059 11.599C10.7957 11.6923 10.9647 11.8284 11.1015 11.9982C11.2382 12.168 11.3394 12.3674 11.3984 12.583C11.4573 12.7986 11.4726 13.0253 11.4431 13.2477L10.8886 17.4308C10.8391 17.8044 10.6661 18.1463 10.4015 18.3937C10.1368 18.6411 9.79817 18.7774 9.44771 18.7777H2.94214V13.5489Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M19.058 0.999758L21 0.999758L21 6.22852L19.058 6.22852" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M19.0579 6.22891L17.1159 12.5034L16.6304 12.5034C16.2441 12.5034 15.8737 12.3382 15.6005 12.044C15.3274 11.7498 15.1739 11.3508 15.1739 10.9348L15.1739 8.32041L11.9988 8.32041C11.7902 8.32042 11.5839 8.27214 11.3941 8.17884C11.2043 8.08554 11.0353 7.94939 10.8985 7.77963C10.7618 7.60986 10.6606 7.41043 10.6016 7.19485C10.5427 6.97927 10.5274 6.75256 10.5569 6.53009L11.1114 2.34708C11.1609 1.97342 11.3339 1.63153 11.5985 1.38412C11.8632 1.13672 12.2018 1.00039 12.5523 1.00015L19.0579 1.00015L19.0579 6.22891Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FeedBackIcon;
